import React, {useState} from 'react';
import TopNavbar from '@bigyellow/components/Layouts/TopNavbar';
import LeftSideMenu from '@bigyellow/components/Layouts/LeftSideMenu';
import Footer from '@bigyellow/components/Layouts/Footer';
import {Container} from 'react-bootstrap';
import {motion} from "framer-motion"


const AccountLayout = (props) => {
    const [sideMenuActive, setSideMenuActive] = useState(true);
    const variants = {
        hidden: {opacity: 0},
        visible: {opacity: 1},
    }
    return (
        <React.Fragment>

            <TopNavbar
                onClick={(active) => setSideMenuActive(active)}
                parentLink={props.parentLink}
                parent={props.parent}
                title={props.title}
                hideLogo
            />
            <LeftSideMenu
                sideMenu={sideMenuActive}
                canCheckin={props.canCheckin}
                overrideSideMenuLinks={props.overrideSideMenuLinks}

            />
            <motion.div
                initial="hidden"
                animate="visible"
                variants={variants}
                transition={{ease: "easeOut", delay: 0.5, duration: 0.5}}
            >
                <Container
                    className={
                        'main-content ' + props.mainContentAdditionalClassNames
                    }
                >
                    {props.children}
                </Container>
            </motion.div>
            <Footer/>
        </React.Fragment>
    );
};
export default AccountLayout;
